import * as React from 'react';
import b_ from 'b_';
import { useTranslation } from 'react-i18next';
import { OrderStatusContentFragment } from './__generated__/OrderStatusContentFragment';
import { getStartDate } from './startDate';

import './index.scss';

type Order = OrderStatusContentFragment;

interface Props {
  order: Order;
}

const b = b_.with('order-card-status-content');

export const Content: React.FC<Props> = ({ order }) => {
  const { t } = useTranslation();

  if (order.isRejected) {
    return <span className={b({ rejected: true })}>{t('Rejected')}</span>;
  }

  if (order.isExecuting) {
    return <span className={b()}>{t('Is executing')}...</span>;
  }

  const startDate = getStartDate(order);

  return (
    <span className={b()}>
      {t('Start')} {startDate || t('Soon')}
    </span>
  );
};
